import {z} from 'zod'
import {TimeEntry} from './TimeEntry.js'
import {MergedRecommendation, Recommendation} from '../recommendation/index.js'

export const DayItem = z.union([
  z.object({
    id: z.string(),
    type: z.literal('time-entry'),
    item: TimeEntry,
  }),
  z.object({
    id: z.string(),
    type: z.literal('recommendation'),
    item: Recommendation,
  }),
  z.object({
    id: z.string(),
    type: z.literal('merged-recommendation'),
    item: MergedRecommendation,
  }),
])
export type DayItem = z.infer<typeof DayItem>
